export let EditarArticuloRouteComponent = {
    selector: 'editarArticuloRoute',
    template: require('./editar-articulo.html'),
    bindings: {
        categorias: '<',
        articulo: '<'
    },
    controller: class {

        categoriaSeleccionada;
        subcategoriaSeleccionada;

        /*@ngInject*/
        constructor(ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService) {
            Object.assign(this, {ArticuloService, $location, Upload, IMAGE_UPLOAD_URL, ToasterService});
        }

        $onInit() {
            // let aux = this.articulo.categoria.split('/');

            this.categoriaSeleccionada = this.categorias.find(item => {
                return item.categoria.toUpperCase() === this.articulo.categoria;
            });
            this.subcategoriaSeleccionada = this.categoriaSeleccionada.subcategorias.find(item => {
                return item.subcategoria.toUpperCase() === this.articulo.subcategoria;
            });

            if (this.articulo.equivalencia && this.articulo.equivalencia.codigo) {
                this.articulo.equivalencia = this.articulo.equivalencia.codigo;
            }
            if (this.articulo.equivalencia2 && this.articulo.equivalencia2.codigo) {
                this.articulo.equivalencia2 = this.articulo.equivalencia2.codigo;
            }
        }

        editarArticulo(form) {

            if (form.$valid) {

                this.articulo.categoria = this.categoriaSeleccionada.categoria.toUpperCase();
                this.articulo.subcategoria = this.subcategoriaSeleccionada.subcategoria.toUpperCase();

                if (this.file) {
                    this.Upload.upload({
                            url: this.IMAGE_UPLOAD_URL,
                            data: {
                                file: this.file
                            }
                        })
                        .then((img) => {
                            this.articulo.imagenUrl = img.data.secure_url;
                            this.ArticuloService.editarArticulo(this.articulo)
                                .then((art) => {
                                    this.ToasterService.popUp('success','Articulo', 'Se ha actualizado con éxito.');
                                    this.$location.path(`/articulo/ver/${art.data._id}`);
                                }, (error) => {
                                    this.ToasterService.popUp('danger', 'Error en articulo', error.data);
                                });
                        })
                } else {
                    this.ArticuloService.editarArticulo(this.articulo)
                        .then((art) => {
                            this.ToasterService.popUp('success','Articulo', 'Se ha actualizado con éxito.');
                            this.$location.path(`/articulo/ver/${art.data._id}`);
                        }, (error) => {
                            this.ToasterService.popUp('danger', 'Error en articulo', error.data);
                        });
                }
            } else {
                this.ToasterService.popUp('info','Formulario', 'Esta incompleto o no es válido.');
            }
        }

        toggleActivo(value){
            this.articulo.activo = value;
        }

        uploadFiles(file, error) {
            this.file = file;
        }


    }
};



// WEBPACK FOOTER //
// ./client/app/articulo-route/editar/editar-articulo.component.js